export const toCurrency = (
    number: number = NaN,
    minFractionDigits = 0,
    maxFractionDigits = 2,
) => {
    if (isNaN(number)) return '-';
    return new Intl.NumberFormat('locale', {
        minimumFractionDigits: minFractionDigits,
        maximumFractionDigits: maxFractionDigits,
    }).format(number);
};

export const toPercentage = (number: number, accuracy?: number) => {
    const defaultAcc = number === Math.round(number) ? 0 : 2;

    return (
        formatNumber(number, {
            style: 'decimal',
            minimumFractionDigits: accuracy ?? defaultAcc,
            maximumFractionDigits: accuracy ?? defaultAcc,
        }) + '%'
    );
};

export const normalizeNumber = (value: any) => {
    const finalValue = (value + '').replace(/\s/g, '').replace(/,/g, '');
    return Number(finalValue);
};

export const formatNumber = (
    number: number,
    options: Intl.NumberFormatOptions,
) => {
    return new Intl.NumberFormat('en', options).format(number);
};

export const getOrdinalSuffix = (number: number) => {
    const remainder10 = number % 10;
    const remainder100 = number % 100;

    if (remainder10 === 1 && remainder100 !== 11) return `${number}st`;
    if (remainder10 === 2 && remainder100 !== 12) return `${number}nd`;
    if (remainder10 === 3 && remainder100 !== 13) return `${number}rd`;

    return `${number}th`;
};

export const roundNumber = (value: number): number => Math.round(value);
